module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAMAAAAMs7fIAAAASFBMVEUAAABUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGZUXGYRfjAxAAAAF3RSTlMA+ZA4MAaRLAvXlOTUmMq7jirYvUQWFW2FQo8AAAB4SURBVBjTZY9ZEsMgDEMlCGtImnTT/W/aMtBmBt7nG9uyUDmPRKbjRMdldbbYxE30NkbrqYerJmtd2vCyKgMI5Fd0RQbAyOOPlwGS7GWsEkA5oEUBThxMFKetMl+e08cPt18LU1sYSuU9NC3a23gwd7KYgNf+xMwHcQwHQ5SbZYUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_narrow.png
// module id = Sciz
// module chunks = 9